import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=01defa38&scoped=true&"
import script from "./Ticket.vue?vue&type=script&lang=ts&"
export * from "./Ticket.vue?vue&type=script&lang=ts&"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=01defa38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01defa38",
  null
  
)

export default component.exports